// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aaBe","rootMobile":"styles_rootMobile__OSvDG"};